export default "__VITE_ASSET__D6_bH3rD__"